// Others
import axiosClient from './axiosClient';
import { IBaseResponse } from '~/utils/interface/base';
import { urlApiFile } from '~/utils/constants/apis';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';

const fileApi = {
  downloadFile(fileId: string) {
    const url = urlApiFile.downloadFile(fileId);
    return axiosClient.get<IBaseResponse<ArrayBuffer>>(url);
  },

  attachFile(formData: FormData) {
    const url = urlApiFile.attachFile;
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },
};

export default fileApi;
